// Formatting utility functions

export function formatCurrency(amount, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(parseFloat(amount));
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

/** Format a date-only value (e.g. expiration) as a calendar date so it matches Shopify (no UTC→local shift). */
export function formatDateOnly(dateString) {
  if (!dateString) return '';
  const s = String(dateString).trim().slice(0, 10);
  const [y, m, d] = s.split('-').map(Number);
  if (!y || !m || !d) return formatDate(dateString);
  const date = new Date(y, m - 1, d);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

export function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

/**
 * Format a phone string as +1 (XXX) XXX-XXXX for US numbers; otherwise return cleaned input.
 * @param {string} phone
 * @returns {string}
 */
export function formatPhoneNumber(phone) {
  if (!phone || !String(phone).trim()) return '';
  const digits = String(phone).replace(/\D/g, '');
  if (digits.length === 10) {
    return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return digits || String(phone).trim();
}